import React from "react";
import "../css/About.css";

const About = () => {
  return (
    <div className="about-page">

      {/* ---------------- HERO ---------------- */}
      <section className="about-hero">
        <h1>ABOUT ACE</h1>
        <p>Strength is built. Discipline is earned. Legends are created.</p>
        <span className="red-line"></span>
      </section>



      {/* ---------------- MISSION ---------------- */}
      <section className="mission-section">
        <h2>OUR MISSION</h2>

        <p>
          ACE Fitness is built for those who demand more — more strength, more focus, 
          more control over their bodies and lives.  
          Our philosophy is simple: **train with purpose, move with precision, and grow relentlessly.**
        </p>

        <div className="mission-stats">
          <div>
            <h3>10+</h3>
            <p>Years of Excellence</p>
          </div>
          <div>
            <h3>5000+</h3>
            <p>Transformations</p>
          </div>
          <div>
            <h3>30+</h3>
            <p>Certified Coaches</p>
          </div>
        </div>
      </section>



      {/* ---------------- VALUES SECTION ---------------- */}
      <section className="values-section">
        <h2 className="section-title">ACE VALUES</h2>

        <div className="values-grid">

          <div className="value-card">
            <h3>STRENGTH</h3>
            <p>We build physical and mental power — one rep at a time.</p>
          </div>

          <div className="value-card">
            <h3>DISCIPLINE</h3>
            <p>Success is earned through consistent effort and commitment.</p>
          </div>

          <div className="value-card">
            <h3>COMMUNITY</h3>
            <p>A supportive environment where everyone grows together.</p>
          </div>

          <div className="value-card">
            <h3>PERFORMANCE</h3>
            <p>Every workout is engineered for progress and precision.</p>
          </div>

        </div>
      </section>



      {/* ---------------- IMAGE + TEXT SPLIT ---------------- */}
      <section className="about-split">
        <div className="split-img img1"></div>

        <div className="split-text">
          <h1>BUILT FOR ATHLETES.  
            <br />MADE FOR EVERYONE.
          </h1>

          <p>
            Whether you're stepping into the gym for the first time or training like a pro,  
            ACE offers personalized programs, world-class trainers, and an environment designed  
            for peak performance.
          </p>
        </div>
      </section>



      {/* ---------------- SECOND SPLIT ---------------- */}
      <section className="about-split reverse">
        <div className="split-text">
          <h1>STATE-OF-THE-ART TRAINING ENVIRONMENT</h1>
      
          <p>
            Equipped with advanced machines, free weights, functional rigs, conditioning zones,  
            and recovery spaces — ACE is engineered to elevate your entire fitness experience.
          </p>
        </div>
      
        <div
          className="split-img img2"
          style={{
            backgroundImage:
              "url('https://images.pexels.com/photos/116077/pexels-photo-116077.jpeg?auto=compress&cs=tinysrgb&w=1200')",
          }}
        />
      </section>



      {/* ---------------- TIMELINE SECTION ---------------- */}
      <section className="timeline-section">
        <h2 className="section-title">THE ACE JOURNEY</h2>

        <div className="timeline">

          <div className="timeline-item">
            <span className="year">2015</span>
            <p>ACE Fitness is founded with the vision of redefining training culture.</p>
          </div>

          <div className="timeline-item">
            <span className="year">2017</span>
            <p>Launched strength, conditioning, and functional training programs.</p>
          </div>

          <div className="timeline-item">
            <span className="year">2020</span>
            <p>Expanded to a multi-floor performance center with advanced equipment.</p>
          </div>

          <div className="timeline-item">
            <span className="year">2023</span>
            <p>Crossed 5,000+ transformations and introduced elite athlete programs.</p>
          </div>

        </div>
      </section>



      {/* ---------------- CTA ---------------- */}
      <section className="about-cta">
        <h1>THIS IS YOUR SIGN TO BEGIN.</h1>
        <button>Join ACE Fitness</button>
      </section>

    </div>
  );
};

export default About;
